/**
 * Function accepts information regarding a field configuration and, using
 * known contsraint keys in the field config, generates and returns a
 * function to be used in automatically client side field validation.
 * @param fieldConfig
 * @returns {Function}
 */
const buildValidation = (fieldConfig) => {
    let validationPoints = {};
    if (fieldConfig.nullable !== undefined && fieldConfig.nullable === false) {
        validationPoints.nullable = (val) => {
            return !(val === undefined || val === null || val === '');
        };
    }
    return (fieldState) => {
        let failed = Object.entries(validationPoints).reduce((failures, [k, v], i) => {
            if (!v(fieldState)) {
                const failedKey = k === 'nullable' ? 'required' : k;

                failures.push(failedKey);
            }
            return failures;
        }, []);
        if (failed.length === 0) {
            return { valid: true, failed: null };
        } else {
            return { valid: false, failed };
        }
    };
};

export default buildValidation;
